import { defineMessages } from 'react-intl'

export default defineMessages({
  assets: {
    id: 'assets',
    defaultMessage: 'Assets',
  },
  _all: {
    id: 'all.assets',
    defaultMessage: 'all Assets',
  },
  Region: {
    id: 'region',
    defaultMessage: 'Region',
  },
  Hub: {
    id: 'hub',
    defaultMessage: 'Hub',
  },
  Territory: {
    id: 'territory',
    defaultMessage: 'Territory',
  },
  Representative: {
    id: 'representative',
    defaultMessage: 'Representative',
  },
  'Sales Office': {
    id: 'salesOffice',
    defaultMessage: 'Sales Office',
  },
  Grower: {
    id: 'grower',
    defaultMessage: 'Grower',
  },
  Farm: {
    id: 'farm',
    defaultMessage: 'Farm',
  },
  Field: {
    id: 'field',
    defaultMessage: 'Field',
  },
  Region_plural: {
    id: 'regions',
    defaultMessage: 'Regions',
  },
  Hub_plural: {
    id: 'hubs',
    defaultMessage: 'Hubs',
  },
  Territory_plural: {
    id: 'territories',
    defaultMessage: 'Territories',
  },
  Representative_plural: {
    id: 'representatives',
    defaultMessage: 'Representatives',
  },
  'Sales Office_plural': {
    id: 'salesOffices',
    defaultMessage: 'Sales Offices',
  },
  Grower_plural: {
    id: 'growers',
    defaultMessage: 'Growers',
  },
  Farm_plural: {
    id: 'farms',
    defaultMessage: 'Farms',
  },
  Field_plural: {
    id: 'fields',
    defaultMessage: 'Fields',
  },
  fieldId: {
    id: 'fieldId',
    defaultMessage: 'ID',
  },
  'Management Zones_plural': {
    id: 'subfields',
    defaultMessage: 'Subfields',
  },
  Harvest_plural: {
    id: 'harvest',
    defaultMessage: 'Harvest',
  },
  'Crop Health_plural': {
    id: 'cropHealth',
    defaultMessage: 'Crop Health',
  },
  Applied_plural: {
    id: 'applied',
    defaultMessage: 'Applied',
  },
  Boundary_plural: {
    id: 'boundaries',
    defaultMessage: 'Boundaries',
  },
  Placemark_plural: {
    id: 'placemarks',
    defaultMessage: 'Placemarks',
  },
  ScoutingObservations_plural: {
    id: 'scouting_observations',
    defaultMessage: 'Scouting Observations',
  },
  all_plural: {
    id: 'all',
    defaultMessage: 'All',
  },
  other_plural: {
    id: 'other',
    defaultMessage: 'Other',
  },
  aFieldWithThisNameAlreadyExistsInThisSeason: {
    id: 'error.existingLabel',
    defaultMessage: 'A field with this name already exists in this season.',
  },
  thisRuleFieldIsNotAValidGeojson: {
    id: 'error.invalidShapeData',
    defaultMessage: 'This rule field is not a valid geojson',
  },
  'asset.label': {
    id: 'asset.label',
    defaultMessage: 'Label',
  },
  'asset.category': {
    id: 'asset.category',
    defaultMessage: 'Category',
  },
  'asset.parent': {
    id: 'asset.parent',
    defaultMessage: 'Parent',
  },
  'asset.shape': {
    id: 'asset.shape',
    defaultMessage: 'Shape',
  },
  'asset.mapped': {
    id: 'asset.mapped',
    defaultMessage: 'Mapped',
  },
  'asset.id': {
    id: 'asset.id',
    defaultMessage: 'Id',
  },
  add: {
    id: 'asset.add',
    defaultMessage: 'Add',
  },
  edit: {
    id: 'asset.edit',
    defaultMessage: 'Edit',
  },
  delete: {
    id: 'asset.delete',
    defaultMessage: 'Delete',
  },
  copy: {
    id: 'asset.copy',
    defaultMessage: 'Copy',
  },
  fieldsTooptip: {
    id: 'asset.fieldsTooptip',
    defaultMessage: 'Fields',
  },
  farmAcres: {
    id: 'farmAcres',
    defaultMessage: 'Farm Acres',
  },
  'error.dependant': {
    id: 'error.dependant',
    defaultMessage: 'No Parent Fields Available. Please Load Fields.',
  },
  'Assets Manager': {
    id: 'Assets Manager',
    defaultMessage: 'Assets Manager',
  },
  labelRequired: {
    id: 'labelRequired',
    defaultMessage: 'Please provide a label.',
  },
  categoryIsRequired: {
    id: 'categoryIsRequired',
    defaultMessage: 'Please select a category.',
  },
  fieldLabelRequired: {
    id: 'fieldLabelRequired',
    defaultMessage: 'Please provide a Field label.',
  },
  farmRequired: {
    id: 'farmRequired',
    defaultMessage: 'Please choose a Farm for this field.',
  },
  seasonRequired: {
    id: 'seasonRequired',
    defaultMessage: 'Please choose a Season for this field.',
  },
})
